export const func = {
    formateDateForDB: (date) => {
        if(!date){
            return null
        }
        let splittedFormat = date.split(".")

        let out = splittedFormat[2]+ "-" + splittedFormat[1] + "-" + splittedFormat[0] + " " + "00:00:00";

        return out
    },
    formateDateFromDB: (date) => {
        if(!date){
            return null
        }
        let dateWithoutTime = date.split(" ");
        let splittedFormat = dateWithoutTime[0].split("-");

        let out = splittedFormat[2]+ "." + splittedFormat[1] + "." + splittedFormat[0];

        return out
    },
    hasFrontendFormat: (date) => {
        if(!date){
            return null
        }
        let val = true;
        if(date.indexOf('-') !== -1){
            val = false
        }
        return val
    }
}